import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import dropbox from '../imgs/dropbox.svg';
import google from '../imgs/google-drive.svg';
import './styles';
import { FILE_SOURCES } from './constants';

@injectIntl
@observer
export default class NewAttachment extends React.Component {
  render() {
    let url;
    const { file, blobUrl } = this.props;
    if (file && file.isExternal) {
      url = file.url;
    } else {
      url = file && blobUrl(file);
    }

    let element;
    if (file.type && file.type.match('image.*')) {
      element = <img src={url} />;
    } else {
      if (file.isExternal) {
        switch (file.source) {
          case FILE_SOURCES.GOOGLE:
            element = <img className={'icon-img'} src={google} />;
            break;
          case FILE_SOURCES.DROPBOX:
            element = <img className={'icon-img'} src={dropbox} />;
            break;
          default:
            element = (
              <div>
                <i className="file-icon fa fa-link"></i>
              </div>
            );
            break;
        }
      } else {
        element = (
          <div>
            <i className="file-icon fa fa-file-o"></i>
          </div>
        );
      }
    }

    let fileName =
      file.name.length > 20 ? file.name.slice(0, 20) + '...' : file.name;

    return (
      <div className="attachment-preview img-thumbnail">
        <i
          className="fa fa-remove"
          onClick={() => this.props.handleRemove(file)}
        ></i>
        <div onClick={this.handleFileClick}>
          <div className="element-container">{element}</div>
          <div className="name">{fileName}</div>
        </div>
      </div>
    );
  }

  handleFileClick = e => {
    const { file } = this.props;
    if (file.isExternal) {
      window.open(file.url, '_blank');
    } else if (
      (file.type && file.type.match('image.*')) ||
      file.type.match('pdf')
    ) {
      window.open(url, '_blank');
    }
  };
}
